import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { systemApplicationFilters } from './system-application.filters';

// `validateSearch` das rotas (U07). Leve de propósito: é JS inicial.

/** Tamanhos da lista do legado (`SystemApplicationList.tsx:128`). */
export const SYSTEM_APPLICATION_PAGE_SIZES = [5, 10, 15, 20, 60] as const;

const sheet = z.string().min(1).max(40).optional().catch(undefined);

export const systemApplicationListSearch = listSearchSchema(
  { ...systemApplicationFilters.shape, sheet },
  { sizes: SYSTEM_APPLICATION_PAGE_SIZES },
);

/** Abas locais do legado, na ordem (SystemApplicationForm.tsx:504–508); a primeira não vai à URL. */
export const SYSTEM_APPLICATION_TABS = ['dados', 'oauth', 'urls', 'autenticacao', 'tokens'] as const;
export type SystemApplicationTab = (typeof SYSTEM_APPLICATION_TABS)[number];

export const systemApplicationDetailSearch = z.object({
  tab: z.enum(SYSTEM_APPLICATION_TABS).optional().catch(undefined),
  sheet,
});
